import configureStore from 'config/store';

var ReactDefaultProps = {
    store: configureStore()
};

export default ReactDefaultProps;
